import Swal from 'sweetalert2';

import { types } from "../types/types";
import { fetchConToken, archivoConToken } from '../helpers/fetch';
import { openModal, openModalBottom } from './ui';
import { refreshServicio } from './servicios';

export const startNewProfesional = (values, swal = true) => {
    return async (dispatch, getState) => {
        try {
            const resp = await fetchConToken('profesionales', values, 'POST');
            const body = await resp.json();
            if (body.ok) {
                const state = getState();
                
                if ( body.profesional.servicios && body.profesional.servicios.length > 0 ) {
                    body.profesional.servicios.forEach( (servicioId) => {
                        const servicioIdStr = typeof servicioId === 'object' && servicioId._id ? servicioId._id.toString() : servicioId.toString();
                        const servicio = state.servicios.servicios.find( s => {
                            const sIdStr = s._id.toString();
                            return sIdStr === servicioIdStr;
                        });
                        if ( servicio ) {
                            const profesionalesActuales = servicio.profesionales || [];
                            const profesionalIdStr = body.profesional._id.toString();
                            if ( !profesionalesActuales.some( pId => {
                                const pIdStr = typeof pId === 'object' && pId._id ? pId._id.toString() : pId.toString();
                                return pIdStr === profesionalIdStr;
                            }) ) {
                                const servicioActualizado = {
                                    ...servicio,
                                    profesionales: [...profesionalesActuales, body.profesional._id]
                                };
                                dispatch( refreshServicio( servicio._id, servicioActualizado ) );
                            }
                        }
                    });
                }
                
                const datos = {
                    text: [`${values.nombre} ha sido añadido/a a los profesionales.`],
                    timeOut: 3
                }
                dispatch(openModalBottom(datos));
                dispatch(addNewProfesional(body.profesional._id, body.profesional));
                dispatch(activeProfesional(body.profesional._id, body.profesional));

                return body.profesional._id;
            } else {
                console.log('Error!!!');
                console.log(body.errors);
            }
        } catch (error) {
            console.log('Error!!!');
            console.log(error);
            const datos = {
                title: 'Error',
                text: ['Ha habido un error'],
                buttonText: 'Cerrar'
            }
            dispatch(openModal(datos));
        }
    }
};

export const activeProfesional = (_id, profesional) => ({
    type: types.profesionalesActive,
    payload: {
        _id,
        ...profesional
    }
});

export const unactiveProfesional = () => ({
    type: types.profesionalesUnactive
});

export const addNewProfesional = (_id, profesional) => ({
    type: types.profesionalesAddNew,
    payload: {
        _id,
        ...profesional
    }
})

export const startLoadingProfesionales = (empresa) => {
    return async (dispatch, getState) => {
        const state = getState();
        
        if (state.profesionales.profesionales && state.profesionales.profesionales.length > 0) {
            const profesionalesEmpresa = state.profesionales.profesionales.filter(p => p.empresa === empresa);
            if (profesionalesEmpresa.length > 0) {
                return;
            }
        }
        
        try {
            const resp = await fetchConToken('profesionales/empresa', { empresa }, 'POST');
            const body = await resp.json();
            dispatch(setProfesionales(body.profesionales));
        } catch (error) {
            console.log(error);
        }
    }
};

export const setProfesionales = (profesionales) => ({
    type: types.profesionalesLoad,
    payload: profesionales
})

export const startSaveProfesional = (profesional, swal = true) => {
    return async (dispatch, getState) => {

        try {
            const resp = await fetchConToken(`profesionales/${profesional._id}`, profesional, 'PUT');
            const body = await resp.json();
            if (body.ok) {
                const stateAntes = getState();
                const profesionalAnterior = stateAntes.profesionales.profesionales.find( p => p._id === profesional._id );
                const serviciosAnteriores = profesionalAnterior?.servicios || [];
                const serviciosNuevos = body.profesional.servicios || [];
                
                dispatch(refreshProfesional(profesional._id, body.profesional));
                
                const state = getState();
                
                const serviciosAgregados = serviciosNuevos.filter( id => {
                    const idStr = typeof id === 'object' && id._id ? id._id.toString() : id.toString();
                    return !serviciosAnteriores.some( antId => {
                        const antIdStr = typeof antId === 'object' && antId._id ? antId._id.toString() : antId.toString();
                        return antIdStr === idStr;
                    });
                });
                
                const serviciosEliminados = serviciosAnteriores.filter( antId => {
                    const antIdStr = typeof antId === 'object' && antId._id ? antId._id.toString() : antId.toString();
                    return !serviciosNuevos.some( nuevoId => {
                        const nuevoIdStr = typeof nuevoId === 'object' && nuevoId._id ? nuevoId._id.toString() : nuevoId.toString();
                        return nuevoIdStr === antIdStr;
                    });
                });
                
                serviciosAgregados.forEach( (servicioId) => {
                    const servicioIdStr = typeof servicioId === 'object' && servicioId._id ? servicioId._id.toString() : servicioId.toString();
                    const servicio = state.servicios.servicios.find( s => {
                        const sIdStr = s._id.toString();
                        return sIdStr === servicioIdStr;
                    });
                    if ( servicio ) {
                        const profesionalesActuales = servicio.profesionales || [];
                        const profesionalIdStr = profesional._id.toString();
                        if ( !profesionalesActuales.some( pId => {
                            const pIdStr = typeof pId === 'object' && pId._id ? pId._id.toString() : pId.toString();
                            return pIdStr === profesionalIdStr;
                        }) ) {
                            const servicioActualizado = {
                                ...servicio,
                                profesionales: [...profesionalesActuales, profesional._id]
                            };
                            dispatch( refreshServicio( servicio._id, servicioActualizado ) );
                        }
                    }
                });
                
                serviciosEliminados.forEach( (servicioId) => {
                    const servicioIdStr = typeof servicioId === 'object' && servicioId._id ? servicioId._id.toString() : servicioId.toString();
                    const servicio = state.servicios.servicios.find( s => {
                        const sIdStr = s._id.toString();
                        return sIdStr === servicioIdStr;
                    });
                    if ( servicio ) {
                        const profesionalesActuales = servicio.profesionales || [];
                        const profesionalIdStr = profesional._id.toString();
                        const nuevosProfesionales = profesionalesActuales.filter( pId => {
                            const pIdStr = typeof pId === 'object' && pId._id ? pId._id.toString() : pId.toString();
                            return pIdStr !== profesionalIdStr;
                        });
                        const servicioActualizado = {
                            ...servicio,
                            profesionales: nuevosProfesionales
                        };
                        dispatch( refreshServicio( servicio._id, servicioActualizado ) );
                    }
                });
                
                const datos = {
                    text: [`Cambios guardados`],
                    timeOut: 3
                }
                dispatch(openModalBottom(datos));
            } else {
                console.log(body);
                const mensajeError = body?.msg || 'Error al guardar el profesional.';
                const datos = {
                    title: 'Error',
                    text: [mensajeError],
                    buttonText: 'Cerrar'
                }
                dispatch(openModal(datos));
            }
        } catch (error) {
            console.log(error);
        }
    }
};

export const refreshProfesional = (id, profesional) => ({
    type: types.profesionalesUpdated,
    payload: {
        ...profesional
    }
});

export const startUploading = (archivo, profesional, nombre, previa) => {

    return async (dispatch, getState) => {
        try {
            const formData = new FormData();
            formData.append('archivo', archivo);
            formData.append('empresa', profesional.empresa);
            formData.append('nombre', nombre);
            formData.append('previa', previa);
            formData.append('file_name', 'archivo');

            const resp = await archivoConToken(`profesionales/upload/${profesional._id}`, formData, 'POST');
            const body = await resp.json();

            if (body.nombre) {
                const updatedProfesional = {
                    ...profesional,
                    img: [body.nombre]
                };
                
                dispatch(activeProfesional(profesional._id, updatedProfesional));
                
                const state = getState();
                const updatedProfesionales = state.profesionales.profesionales.map(p => 
                    p._id === profesional._id ? updatedProfesional : p
                );
                dispatch(setProfesionales(updatedProfesionales));
            }
        } catch (error) {
            console.error('Error uploading file:', error);
        }

        Swal.close();
    }
};

export const profesionalStartDelete = (id, empresa) => {
    return async (dispatch, getState) => {
        console.log('deleted');

        try {
            const resp = await fetchConToken(`profesionales/${id}`, { empresa }, 'DELETE');
            const body = await resp.json();

            if (body.ok) {
                dispatch(profesionalDeleted(id));
            } else {
                const datos = {
                    title: 'Error',
                    text: [body.msg],
                    buttonText: 'Cerrar'
                }
                dispatch(openModal(datos));
            }


        } catch (error) {
            console.log(error);
        }
    }
}

// El envío recorre todos los clientes del profesional contra el proveedor de SMS.
const TIMEOUT_ENVIO_AVISO_SMS = 120000;

const mostrarErrorAvisoSms = (dispatch, msg) => {
    dispatch(openModal({
        title: 'Error',
        text: [msg || 'No se ha podido completar la operación'],
        buttonText: 'Cerrar'
    }));
};

export const startObtenerDestinatariosAvisoSms = (profesionalId) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(`profesionales/${profesionalId}/aviso-sms`);
            const body = await resp.json();
            if (body.ok) return body;
            mostrarErrorAvisoSms(dispatch, body.msg);
        } catch (error) {
            console.log(error);
            mostrarErrorAvisoSms(dispatch);
        }
        return null;
    }
};

export const startEnviarAvisoSms = (profesionalId, mensaje) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(`profesionales/${profesionalId}/aviso-sms`, { mensaje }, 'POST', TIMEOUT_ENVIO_AVISO_SMS);
            const body = await resp.json();
            if (body.ok) return body;
            mostrarErrorAvisoSms(dispatch, body.msg);
        } catch (error) {
            console.log(error);
            mostrarErrorAvisoSms(dispatch);
        }
        return null;
    }
};

const profesionalDeleted = (id) => ({
    type: types.profesionalesDelete,
    payload: id
});

export const profesionalLogout = () => ({
    type: types.profesionalesLogoutCleaning
});
